<figure class="highcharts-figure" *ngIf="chartOptions" [style.width]="orientation === 'portrait' ? '170%' : '100%'">
    <highcharts-chart class="highcharts-figure" [Highcharts]="Highcharts" [options]="chartOptions">
    </highcharts-chart>
</figure>